import { environment } from '../../../environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

export class ServiceBase {

  protected requestHeaders() {
      // 增加後面2個set, 因IE會自己用cache, 導致第一次取出資料後, 就會一直用cache, 所以資料有更新, 它也不會重取-->只要用2個set就可搞定, 以下是說明的網站
      // tslint:disable-next-line: max-line-length
      // http://www.coding.nctu.me/%E9%80%8F%E9%81%8E-angular-cli-%E7%94%A2%E7%94%9F%E7%9A%84%E5%89%8D%E7%AB%AF%E7%A8%8B%E5%BC%8F%E5%9C%A8-ie11-%E7%84%A1%E6%B3%95%E6%AD%A3%E7%A2%BA%E5%9F%B7%E8%A1%8C/
    return new HttpHeaders({ 'Content-type': 'application/json'}).set('Cache-Control', 'no-cache').set('Pragma', 'no-cache');
  }

  protected requestHeadersForm() {
    // 增加後面2個set, 因IE會自己用cache, 導致第一次取出資料後, 就會一直用cache, 所以資料有更新, 它也不會重取-->只要用2個set就可搞定, 以下是說明的網站
    // tslint:disable-next-line: max-line-length
    // http://www.coding.nctu.me/%E9%80%8F%E9%81%8E-angular-cli-%E7%94%A2%E7%94%9F%E7%9A%84%E5%89%8D%E7%AB%AF%E7%A8%8B%E5%BC%8F%E5%9C%A8-ie11-%E7%84%A1%E6%B3%95%E6%AD%A3%E7%A2%BA%E5%9F%B7%E8%A1%8C/
  return new HttpHeaders({ 'Access-Control-Allow-Origin': environment.apiUrl,
  'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
  'Access-Control-Max-Age': '86400'});
}

  protected handleError(error: any) {
    console.log('handleError', error);
    if ( error.status === 0 ) {
        // tslint:disable-next-line: deprecation
        return throwError(() => new Error('無法連線至伺服器!'));
    }

    if (error.status === 401) {
        console.log('error.error401', error.error);
        if ( error.error ) {
            // tslint:disable-next-line: deprecation
            return throwError(() => new Error(error.error));
        } else {
            // tslint:disable-next-line: deprecation
            return throwError(() => new Error('請重新登入'));
        }
    }
    if (error.status === 402) {

            return throwError(() => new Error('帳號或密碼錯誤'));

    }

    if (error.status === 404) {
        // console.log('error.error', error.error);

            return throwError(() => new Error('查無資料'));

    }

    if (error.status === 500) {
        console.log('error', error);
        if ( error.error ) {
            // tslint:disable-next-line: deprecation
            return throwError(() => new Error(error.error.InnerMessage));
        } else {
            // tslint:disable-next-line: deprecation
            return throwError(() => new Error('發生非預期的錯誤'));
        }
    }

    const applicationError = error.headers.get('Application-Error');
    if (applicationError) {
        // tslint:disable-next-line: deprecation
        return throwError(() => new Error(applicationError));
    }

    const err = error.error;
    // tslint:disable-next-line: no-shadowed-variable
    const isArray = ( err: any ) => {
        return (Object.prototype.toString.call(err) === '[object Array]');
    };

    let modelStateErrors = '';
    // if (isArray) {
        for (const key in err) {
            if (err[key]) {
                modelStateErrors += err[key] + '\n';
            }
        }
    // } else {
    //     modelStateErrors = error.error;
    // }

    // tslint:disable-next-line: deprecation
    return throwError(() => new Error(
        modelStateErrors || '伺服器異常!'
    ));
  }
}
